// Corpus-free category definitions — safe for client bundles.
export type BusinessFaqCategory =
  | "interpreter"
  | "boi-investment"
  | "corporate"
  | "tax-accounting"
  | "expat-vip";

export interface BusinessCategoryDef {
  slug: BusinessFaqCategory;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  matchTh: RegExp;
  matchEn: RegExp;
}

export const BUSINESS_FAQ_CATEGORIES: BusinessCategoryDef[] = [
  {
    slug: "interpreter",
    titleTh: "ล่ามราชการและล่ามศาล",
    titleEn: "Interpreters — Government & Court",
    descTh: "คุณสมบัติล่าม การจองล่วงหน้า ค่าบริการ และล่ามชั้นศาล",
    descEn: "Interpreter requirements, booking lead time, pricing and court interpreting.",
    matchTh: /(ล่าม|แปลปากเปล่า|ศาล)/,
    matchEn: /(interpret|court)/i,
  },
  {
    slug: "boi-investment",
    titleTh: "BOI และการลงทุนต่างชาติ",
    titleEn: "BOI & Foreign Investment",
    descTh: "บัตรส่งเสริม BOI, e-Expert, ใบอนุญาตต่างด้าว และสัดส่วนการถือหุ้น",
    descEn: "BOI promotion, e-Expert filings, Foreign Business License and shareholding limits.",
    matchTh: /(BOI|ส่งเสริม|ถือหุ้นเกิน|ต่างด้าว|ลงทุน)/i,
    matchEn: /(boi|foreign business|invest|own more than|shareholding)/i,
  },
  {
    slug: "corporate",
    titleTh: "เอกสารนิติบุคคลและ M&A",
    titleEn: "Corporate Documents & M&A",
    descTh: "ควบรวมกิจการ ซื้อขายหุ้น หนังสือมอบอำนาจ และสาเหตุที่เอกสารถูกตีกลับ",
    descEn: "M&A, share transfers, powers of attorney and why corporate files get rejected.",
    matchTh: /(ควบรวม|หุ้น|บริษัท|มอบอำนาจ|ตีกลับ|ด่วน|เดินเรื่อง)/,
    matchEn: /(m&a|share|corporate|power of attorney|reject|one day|agent)/i,
  },
  {
    slug: "tax-accounting",
    titleTh: "บัญชี ภาษี และงบการเงิน",
    titleEn: "Tax, Accounting & Financial Statements",
    descTh: "งบการเงิน หนังสือรับรองถิ่นที่อยู่ทางภาษี R.O.21/22 และ 180 วัน",
    descEn: "Audited statements, R.O.21/22 tax certificates and the 180-day residency rule.",
    matchTh: /(ภาษี|งบการเงิน|สรรพากร|180 วัน|หัก ณ ที่จ่าย)/,
    matchEn: /(tax|financial statement|revenue department|180 days|withhold)/i,
  },
  {
    slug: "expat-vip",
    titleTh: "Expat VIP และการตั้งถิ่นฐาน",
    titleEn: "Expat VIP & Relocation",
    descTh: "แพ็กเกจดูแลชาวต่างชาติแบบครบวงจร ตั้งแต่ก่อนเดินทางถึงหลังตั้งถิ่นฐาน",
    descEn: "End-to-end relocation concierge from pre-arrival to settled-in support.",
    matchTh: /(Expat|VIP|ตั้งถิ่นฐาน|ใบขับขี่|เปิดบัญชี)/i,
    matchEn: /(expat|vip|relocat|driving licence|bank account)/i,
  },
];

export function getBusinessCategoryDef(slug: string): BusinessCategoryDef | undefined {
  return BUSINESS_FAQ_CATEGORIES.find((c) => c.slug === slug);
}
